import React, { useState } from 'react'
import { GButton, GInput } from 'tennders-common/form/components'
import useSession from 'tennders-auth/hooks/useSession'
import GHref from 'tennders-market/common/components/element/GHref'
import useTranslation from 'next-translate/useTranslation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'

const CounterOffer = ({ sendBid, submitting, onClose, counterTo, sharedTransaction, transaction }) => {
  const { isShipperUser, isCarrierUser } = useSession()
  const [form, setForm] = useState({
    bid: null,
    sharedTransaction,
    counterTo
  })
  const { t } = useTranslation()
  const onChange = (k, v) => {
    setForm({ ...form, [k]: v })
  }

  return (
    <div className="tennders-under-neg-counter-offer bg-color-white br-6 p-16">
      <GHref onClick={onClose} className="tennders-under-neg-counter-offer-close-btn pos-abs-top-right text-18">
        <FontAwesomeIcon icon={faCircleXmark} aria-hidden="true" />
      </GHref>
      <div className="d-flex">
        <GInput
          form={form}
          onChange={onChange}
          type="currency"
          eClass="mr-8"
          label={t('offer:enter_your_offer')}
          className="form-input small bg-color-white"
          name="bid"
          placeholder={t('offer:your_price')}
        />
        {!transaction?.isMarketPlaced && false && (
          <GInput
            form={form}
            onChange={onChange}
            type="number"
            eClass="mr-8"
            label={t('offer:payment_days')}
            className="form-input small bg-color-white"
            name="days"
            autoComplete="new-password"
            placeholder={t('offer:days')}
          />
        )}
      </div>
      <div className="text-right">
        <GButton
          disabled={!form.bid || submitting}
          onClick={() => sendBid(form)}
          submitting={submitting}
          className="btn standard-btn small bold mt-8 text-13 p-10"
        >
          {t('offer:' + (isShipperUser || isCarrierUser ? 'quote' : 'sendBid'))}
        </GButton>
      </div>
    </div>
  )
}
export default CounterOffer
